// © 2015-2021 WDNA - All Rights Reserved

const WASTE_COLORS: Record<string, string> = {
  SUW: '#A9A9A9',
  FOR: '#654321',
  PAP: '#3895D3',
  PET: '#F7DC10',
  GLA: '#0B6623',
  PNG: '#735902',
  CRK: '#8C1F28',
};

const WASTE_TITLES: Record<string, string> = {
  SUW: 'URBAN SOLID',
  FOR: 'ORGANIC',
  PAP: 'PAPER',
  PET: 'LIGHT PACKAGING',
  GLA: 'GLASS',
  PNG: 'PRUNING',
  CRK: 'CROCKERY',
};

const WASTE_ORDER: string[] = [
  'SUW',
  'FOR',
  'PAP',
  'PET',
  'GLA',
  'PNG',
  'CRK',
];

/**
 * Function to merge data for histogram
 *
 * @param chartData data of the histogram
 * @returns array with data for the histogram
 */
export function mergeDataForHistogram(chartData: any[]): any[] {
  const histogram: any[] = chartData.map((wasteInfo: any) => {
    const { name, data } = wasteInfo || {};

    const serie: any = data.map((point: any): any[] => {
      const { x, y } = point;
      return [x, y];
    });

    return {
      id: name, // only for sorting purposes
      data: serie,
      type: 'column',
      name: WASTE_TITLES[name] || name,
      color: WASTE_COLORS[name] || undefined,
    };
  });

  histogram.sort((a: any, b: any) => {
    const wasteA: string = a.id;
    const wasteB: string = b.id;

    const orderA: number = WASTE_ORDER.indexOf(wasteA);
    const orderB: number = WASTE_ORDER.indexOf(wasteB);

    if (orderA > orderB) return 1;
    if (orderA < orderB) return -1;

    return 0;
  });

  return histogram;
}
